import { TransportCompanyOptionDto } from '../../../dto/transportCompany';
import { fetchTransportCompanyOptions } from '../api/transportCompanyApi';
import { useReferenceOptions } from '../../reference-data/queries/useReferenceOptions';

export function useTransportCompanyOptions(enabled = true) {
  return useReferenceOptions<TransportCompanyOptionDto>(fetchTransportCompanyOptions, enabled);
}
